import {TableThingyView} from '../view/table_view';
import {connect} from "react-redux";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';
import { requestDataFromAPI} from '../thunk/table_tunc';

interface OwnProps {
    id:string;
}

function mapStateToProps(state:RootState, ownProps:OwnProps){  
    const myprops=
    {
        data:state.vuln_summary_table.model,
        view:state.vuln_summary_table.view
    }
    return myprops;
}

function bindDispatchToActions(dispatch:Dispatch<any>, ownProps:OwnProps){
    return {
        onLoadRequested:()=>{ 
            dispatch(requestDataFromAPI() as any);
        },
    }
}


const TableVulnerabilityContainer=connect(mapStateToProps, bindDispatchToActions)(TableThingyView);
export default TableVulnerabilityContainer;